import React, { useEffect, useState } from 'react';
import NavBar from '../Navigation/NavBar';
import Footer from './LandingPage/Footer';
import { Dialog, useMediaQuery } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axios from 'axios';
import CloseIcon from "@mui/icons-material/Close";
import star from "../../assets/noto_star.png";
import threedot from "../../assets/three-dot.png";
import WhatAppMobile from './LandingPage/WhatAppMobile';

function TeacherSec() {
  const isXs = useMediaQuery('(min-width:600px) and (max-width:3000px)');
  const [facultyData, setFacultyData] = useState([]);
  const [teacherPop, setTeacherPop] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const teacherPopupclose = () => {
    setTeacherPop(false);
    setSelectedItem(null);
  };

  const teacherPopupopen = (item) => {
    setTeacherPop(true);
    setSelectedItem(item);
  };

  async function expertFaculty() {
    const token = { token: 'abcd123' };
    try {
      const response = await axios.post(`https://app.kanhahometutions.com/api/v1/expertFaculties`, token);
      setFacultyData(response.data.data);
    } catch (error) {
      console.error("Error", error);
    }
  }

  useEffect(() => {
    expertFaculty();
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchClick = async () => {
    const payload = {
      search: searchTerm,
      token: 'abc123'
    };

    try {
      const response = await axios.post("https://app.kanhahometutions.com/api/v1/expertFaculties", payload);
      setFacultyData(response.data.data);
    } catch (error) {
      console.error("Error search results:", error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearchClick();
    }
  };

  return (
    <>
    <WhatAppMobile/>
      <NavBar />
      <div style={{ backgroundColor: '#CB8B65', display: 'flex', alignItems: 'center', paddingLeft: isXs ? '6rem' : '1rem', gap: '10px', height: '50px' }}>
        <div><a style={{ color: 'white', textDecoration: 'none', fontSize: '1rem' }} href="/">Home</a></div>
        <ArrowForwardIosIcon style={{ fontSize: '14px', color: 'white' }} />
        <div style={{ fontSize: '1rem', color: 'white' }}>Expert Faculty</div>
      </div>

      <div style={{ fontSize: isXs ? '26px' : '17px', fontWeight: '500', textAlign: 'center', backgroundColor: '#F6EBDC', paddingTop: '30px' }}>
        Explore Our Experienced Tutors
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#F6EBDC' }}>
        <input
          style={{
            fontSize: '16px',
            height: '40px',
            width: isXs ? '490px' : '280px',
            paddingLeft: '10px',
            border: '0px',
            color: 'black',
            marginTop: '10px'
          }}
          type="text"
          placeholder="Search Expert Faculty"
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        <div
          style={{
            fontSize: isXs ? '16px' : '14px',
            textAlign: 'center',
            height: '40px',
            padding: isXs ? '8px 20px' : "10px 10px",
            color: 'white',
            cursor: 'pointer',
            backgroundColor: '#CB8B65',
            marginTop: '10px'
          }}
          onClick={handleSearchClick}
        >
          Search
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: isXs ? 'repeat(4, 1fr)' : 'repeat(1, 1fr)', rowGap: '30px', backgroundColor: '#F6EBDC', padding: '50px 50px 18rem 50px' }}>
        {facultyData.length > 0 ? (
          facultyData.map((item, index) => (
            <div key={index}>
              <div style={{
                height: 'auto',
                width: '280px',
                border: '1.5px solid white',
                borderRadius: '8px',
                backgroundColor: 'rgba(255, 255, 255, 0.4)',
                display: 'flex',
                margin: '0 auto',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '15px',
                padding: '30px 0px'
              }}>
                <div style={{ height: '100px', width: '100px' }}>
                  <img
                    style={{
                      height: '100%',
                      width: '100%',
                      objectFit: 'contain',
                      borderRadius: '50%',
                      backgroundColor: 'white'
                    }}
                    src={item.facultyImage}
                    alt=""
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ color: 'black', fontSize: '20px', fontWeight: '600' }}>{item.facultyName}</div>
                  <div style={{ fontSize: '15px' }}> { item.facultyQualification.length > 30 ? item.facultyQualification.substring(0, 30) + '...': item.facultyQualification}</div>
                </div>
                <div style={{ fontSize: '15px', border: '1px solid lightgrey', padding: '10px 15px', borderRadius: '5px', color: 'black' }}>
                  {item.facultyExperiance} {item.facultyYear} of Experience
                </div>
                <div
                  style={{
                    fontSize: '15px',
                    color: '#8e5431',
                    fontWeight: '500',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: 'calc(100% - 30px)',
                    textAlign: 'center'
                  }}
                >
                  {item.facultySubject.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} {item.facultyClass}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div
                    onClick={() => teacherPopupopen(item)}
                    style={{ fontSize: '15px', backgroundColor: "#8e5431", padding: '7px 20px', borderRadius: '10px', color: 'white', cursor: 'pointer' }}
                  >
                    Profile
                  </div>
                  <a href="/student-signin" style={{ textDecoration: 'none', fontSize: '15px', backgroundColor: "#8e5431", padding: '7px 10px', borderRadius: '10px', color: 'white', cursor: 'pointer' }}>Login as Student</a>
                </div>
              </div>
            </div>
          ))
        ) : (<div>No data found</div>)}
      </div>

      <Dialog
        open={teacherPop}
        sx={{ "& .MuiDialog-container": { "& .MuiPaper-root": { width: "100%", maxWidth: "550px", } } }} >
        <div
          onClick={teacherPopupclose}
          style={{ position: 'absolute', top: '5px', right: "5px", zIndex: '2', cursor: 'pointer', backgroundColor: 'white', borderRadius: '50%' }}
        >
          <CloseIcon style={{ borderRadius: '50%', border: '1px', color: 'black' }} />
        </div>

        <div style={{ minHeight: '450px', position: 'relative' }}>
          <div style={{ backgroundColor: '#E0E0E0', height: '120px', top: '200px' }}></div>

          <div style={{ position: 'absolute', display: 'flex', top: '20px' }}>
            <img
              style={{
                margin: '0px 20px',
                borderRadius: '50%',
                border: '1px solid gray'
              }}
              height={90}
              width={90}
              src={selectedItem?.facultyImage}
              alt="Shikha"
            />
            <div>
              <div style={{ fontSize: '22px', marginTop: "20px", fontWeight: '600' }}>{selectedItem?.facultyName}</div>
              <div style={{ fontSize: '20px' }}>{selectedItem?.facultyQualification}</div>
            </div>
          </div>

          <div style={{ height: "350px" }}>
            <div style={{ display: "flex", alignItems: 'center', gap: '10px', padding: '0px 20px', marginTop: '30px' }}>
              <img height={20} width={20} src={star} alt="star" />
              <div style={{ fontSize: '16px', fontWeight: '500' }}>Experience</div>
              <div style={{ fontSize: '14px' }}>{selectedItem?.facultyExperiance} {selectedItem?.facultyYear} of Experience</div>
            </div>

            <div style={{ display: "flex", alignItems: 'center', gap: '10px', marginTop: '10px', padding: '0px 20px' }}>
              <img height={20} width={20} src={threedot} alt="3dot" />
              <div style={{ fontSize: '16px', fontWeight: '500' }}>Expertise Subject</div>
              <div style={{ fontSize: '14px' }}>{selectedItem?.facultySubject} for {selectedItem?.facultyClass}</div>
            </div>
            <hr style={{ border: '1px solid gray', margin: '20px 20px' }} />
            <div style={{ padding: "0px 20px", fontSize: '16px', fontWeight: '500 ', marginBottom: '10px' }}>Description</div>
            <div style={{ padding: '0px 20px', fontSize: '14px', paddingBottom: '20px' }}>{selectedItem?.facultyDescription}</div>
          </div>
        </div>
      </Dialog>

      <Footer />
    </>
  );
}

export default TeacherSec;


